import { palettes } from "@/config/site";
import { SEO, breadcrumbLd } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTA } from "@/components/CTA";
import { PaletteSelector } from "@/components/PaletteSelector";

export default function Colours() {
  return (
    <>
      <SEO
        title="Colour Palette Selector | North Ember Painting — Delta, BC"
        description="Explore coordinated light, neutral and bold paint palettes with a live room preview. Inspiration for your Delta, BC painting project — always confirm with a physical sample."
        path="/colours"
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Colour Palette Selector", path: "/colours" }])]}
      />
      <PageHero
        eyebrow="Colour palette selector"
        title="Find the palette that feels like home"
        intro="Explore coordinated palettes inspired by the coast, the forest and the ember we're named after — and preview them on a room before you commit."
        image="swatchDeck"
      />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <PaletteSelector />
          </Reveal>
          <Reveal className="mt-16">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {palettes.map((p) => (
                <div key={p.id} className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm">
                  <div className="flex gap-1.5">
                    {p.colors.slice(0, 6).map((c) => (
                      <span key={c.name} className="h-8 w-8 rounded-lg border border-slate-200" style={{ backgroundColor: c.hex }} title={c.name} aria-hidden="true" />
                    ))}
                  </div>
                  <h2 className="mt-4 font-display text-lg font-semibold text-slate-900">{p.name}</h2>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{p.blurb}</p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal className="mt-12">
            <p className="max-w-3xl text-sm leading-relaxed text-slate-500">
              A note on accuracy: screens render colour differently from real paint, and room lighting changes
              everything. Use this tool to explore directions — then confirm your final choice with a physical
              sample on the actual wall. Palette names are our own inspiration names, not tied to any paint brand.
            </p>
          </Reveal>
        </div>
      </section>
      <CTA title="Found a direction you like? Let's make it real" />
    </>
  );
}
